import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import SortInput from '../SortInput';
import Sort from '../Sort';
import Messages from './Messages';

class UsersSearch extends React.Component {
  setSearchQuery = query => {
    if (query.length >= 2) {
      this.props.setSearchQuery(query);
    } else {
      this.props.setSearchQuery('');
    }
  };

  render() {
    const messages = Messages();
    const placeholderDefaultText = this.props.intl.formatMessage({
      ...messages.search_box_device_list,
    });
    const placeholder = this.props.searchQuery
      ? this.props.searchQuery
      : placeholderDefaultText;
    const valueholder = this.props.searchQuery;

    if (this.props.usersCount || this.props.searchQuery) {
      return (
        <Sort >
          <SortInput
            className="SortInput__search"
            name="device"
            title=""
            placeholder={placeholder}
            valuholder={valueholder}
            onChange={this.setSearchQuery}
          />
        </Sort>
      );
    }
    return null;
  }
}

UsersSearch.propTypes = {
  setSearchQuery: PropTypes.func.isRequired,
  searchQuery: PropTypes.string,
  intl: intlShape.isRequired,
  usersCount: PropTypes.number.isRequired,
};

UsersSearch.defaultProps = {
  searchQuery: '',
};

export default injectIntl(UsersSearch);



// WEBPACK FOOTER //
// ./src/components/Popup/UsersSearch.js